<template>
  <BModal size="md" body-class="rounded-lg p-5" :visible="visible" hide-header hide-footer @hide="$emit('hide', true)">
    <div class="p-0">
      <div class="text-center mb-3">
        <i class="far fa-building fa-5x mb-4 text-callout" />
        <h4 v-if="user && user.current_company" class="font-weight-bold text-dark">
          Welcome {{ user.name }} from <span class="font-weight-bold">{{ user.current_company.name }}</span>
        </h4>

        <p class="">You are not associated with any buyer companies so you will be unable to order products.</p>
      </div>
      <div class="border rounded shadow-sm">
        <div v-if="companies.length > 0" class="rounded bg-white">
          <div
            v-for="(company, index) in companies"
            :key="index"
            :class="`${
              selectedCompany.id == company.id ? 'bg-light' : 'bg-white'
            } p-3 rounded border-bottom d-flex align-items-center justify-content-between`"
          >
            <div class="d-flex align-items-center">
              <img
                :style="{
                  height: '32px',
                  width: '32px',
                  borderRadius: '50%',
                  border: '1px solid #ddd',
                }"
                :src="company.logoLink"
              />
              <div class="ml-3">
                <p style="font-weight: 500; line-height: 16px" class="m-0 text-capitalize">
                  {{ company.name }}
                </p>
                <p class="m-0 text-sm text-muted">
                  {{ company.subscription }} <span v-if="sellerCompany && company.id == sellerCompany.id">/ Seller Company</span>
                </p>
              </div>
            </div>
            <BushelBtn v-if="selectedCompany.id !== company.id" class="btn-sm" variant="primary" @click="() => selectCompany(company)">
              Select
            </BushelBtn>
            <BushelBtn v-else class="btn-sm" disabled variant="success"> Selected </BushelBtn>
          </div>
        </div>
      </div>
      <div class="text-center">
        <p class="m-0 text-sm mt-3">
          You can just click outside of this popup or click the close button to close and continue browsing. Anytime you want to switch your company
          you can click the switch company button.
        </p>
        <BushelBtn outline class="btn-sm mt-3" variant="primary" @click="$emit('hide', true)"> Close </BushelBtn>
      </div>
    </div>
  </BModal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companies: {
      type: Array,
      default: () => [],
    },
    sellerCompany: {
      type: Object,
    },
    selectedCompany: {
      type: Object,
      default: () => {},
    },
    user: {
      type: Object,
    },
  },
  emits: ["selected"],
  data() {
    return {};
  },
  methods: {
    selectCompany(company) {
      this.$emit("selected", company);
    },
  },
};
</script>
